export default {
  // Dashboard
  shipmentPerDay: 'Daily Message Volume',
  monthlyShipments: 'Monthly Message Volume',
  currentMonth: 'This Month',
  previousMonth: 'Last Month',
  ALIMTALK_BA: 'Alimtalk B',
  ALIMTALK_EX: 'Alimtalk E',
  ALIMTALK_AD: 'Alimtalk A',
  ALIMTALK_MI: 'Alimtalk M',
  FRIENDTALK_TEXT: 'Friendtalk T',
  FRIENDTALK_IMAGE: 'FriendTalk I',
  FRIENDTALK_WIDE_IMAGE: 'FriendTalk W',
  FRIENDTALK_WIDE_ITEM_LIST: 'FriendTalk WI',
  FRIENDTALK_COMMERCE: 'FriendTalk C',
  FRIENDTALK_CAROUSEL_FEED: 'FriendTalk CF',
  FRIENDTALK_CAROUSEL_COMMERCE: 'FriendTalk CC',
  FRIENDTALK_PREMIUM_VIDEO: 'FriendTalk P',
  sameDayShipment: 'Daily Message Volume',
  currentMonthShipments: 'Current Month Volume',
  previousMonthShipments: 'Previous Month Volume',
  dataCriteria: 'Data Reference',
  SMS: 'SMS',
  LMS: 'LMS',
  MMS: 'MMS',
};
